import { render, staticRenderFns } from "./UpNextCalendarDesktop.vue?vue&type=template&id=68d7a54d&scoped=true&"
import script from "./UpNextCalendarDesktop.vue?vue&type=script&lang=js&"
export * from "./UpNextCalendarDesktop.vue?vue&type=script&lang=js&"
import style0 from "./UpNextCalendarDesktop.vue?vue&type=style&index=0&id=68d7a54d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d7a54d",
  null
  
)

export default component.exports